import { useEffect, useState } from "react";
import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES } from "@/mocks/site";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={whatsappUrl(WA_MESSAGES.general)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Pedir por WhatsApp"
      className={`group fixed right-5 z-50 flex items-center gap-3 rounded-full bg-primary-500 py-0 pl-0 pr-0 text-background-50 transition-all duration-300 hover:bg-primary-600 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
      style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom))" }}
    >
      <span className="relative flex h-[60px] w-[60px] items-center justify-center md:h-16 md:w-16">
        <span className="absolute inset-0 rounded-full bg-primary-500 animate-pulse-ring" aria-hidden="true" />
        <i className="ri-whatsapp-line relative text-3xl leading-none md:text-4xl" aria-hidden="true" />
      </span>
      <span className="hidden max-w-0 overflow-hidden whitespace-nowrap pr-0 text-sm font-medium text-background-50 transition-all duration-300 group-hover:max-w-[220px] group-hover:pr-6 md:block">
        Pedir por WhatsApp
      </span>
    </a>
  );
}